/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestCreateNoticeRequest
 */
export interface RequestCreateNoticeRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestCreateNoticeRequest
     */
    baseId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateNoticeRequest
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateNoticeRequest
     */
    displayAt: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateNoticeRequest
     */
    tenantId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateNoticeRequest
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateNoticeRequest
     */
    userId: number;
    /**
     * nil => true
     * @type {boolean}
     * @memberof RequestCreateNoticeRequest
     */
    visible?: boolean;
}

/**
 * Check if a given object implements the RequestCreateNoticeRequest interface.
 */
export function instanceOfRequestCreateNoticeRequest(value: object): value is RequestCreateNoticeRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('displayAt' in value) || value['displayAt'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestCreateNoticeRequestFromJSON(json: any): RequestCreateNoticeRequest {
    return RequestCreateNoticeRequestFromJSONTyped(json, false);
}

export function RequestCreateNoticeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCreateNoticeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'content': json['content'],
        'displayAt': json['display_at'],
        'tenantId': json['tenant_id'],
        'title': json['title'],
        'userId': json['user_id'],
        'visible': json['visible'] == null ? undefined : json['visible'],
    };
}

export function RequestCreateNoticeRequestToJSON(json: any): RequestCreateNoticeRequest {
    return RequestCreateNoticeRequestToJSONTyped(json, false);
}

export function RequestCreateNoticeRequestToJSONTyped(value?: RequestCreateNoticeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'content': value['content'],
        'display_at': value['displayAt'],
        'tenant_id': value['tenantId'],
        'title': value['title'],
        'user_id': value['userId'],
        'visible': value['visible'],
    };
}

